export default "/static/webpack/media/skill-model.en.78a73544.png";